<template>
  <div>
    <header-component />
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header">
          <h3 class="mb-0" style="text-transform: capitalize">
            Bill Requests List
          </h3>
        </div>
        <el-table
          :data="allBillRequests"
          style="width: 100%"
          header-row-class-name="thead-light"
          v-loading="loading"
        >
          <el-table-column label="Requested Date" min-width="120">
            <template slot-scope="scope">{{
              scope.row.billRequestedDate | dateFormat
            }}</template>
          </el-table-column>
          <el-table-column
            label="Service Request No."
            prop="serviceRequestNumber"
            min-width="150"
          />
          <el-table-column label="Customer Name" min-width="150">
            <template slot-scope="scope">
              {{ scope.row.customerName }}
            </template>
          </el-table-column>

          <el-table-column label="Vendor Name" min-width="150">
            <template slot-scope="scope">
              {{ scope.row.vendorName }}
            </template>
          </el-table-column>
          <el-table-column label="Status" min-width="150">

         
            <template slot-scope="scope">
             <span class="badge badge-pill" :class="{'badge-success': scope.row.status === 'completed', 'badge-danger': scope.row.status === 'cancelled', 'badge-warning': scope.row.status === 'pending'}">{{ scope.row.status }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Actions" width="150">
            <template slot-scope="scope">
              <base-button
                v-if="scope.row.status === 'pending'"
                type="primary"
                size="sm"
                @click="handleGenerateBill(scope.row)"
                :loading="scope.row.generating"
                >
                  Generate Bill
                </base-button>
              <base-button
              disabled
                v-else
                type="primary"
                size="sm"
                
              >
                View Bill
              </base-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="card-footer">
          <div
            v-if="billRequestMeta"
            slot="footer"
            class="flex-wrap col-12 d-flex justify-content-center justify-content-sm-between"
          >
            <div class>
              <p class="card-category">
                Showing {{ billRequestMeta.from  }} to
                {{ billRequestMeta.to }} of {{ billRequestMeta.total }} entries
              </p>
            </div>
            <pagination :meta="billRequestMeta" @paginate="setPagination" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerComponent from "../Components/HeaderComponent";
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import dateFns from "date-fns";
import pagination from "@/components/AmsaPagination";

import { Table, TableColumn, Button } from "element-ui";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    pagination,
    "header-component": headerComponent
  },
  filters: {
    dateFormat(value) {
      if (!value) return "-";
      return dateFns.format(new Date(value), "DD MMM YYYY HH:mm A");
    }
  },
  data: () => {
    return {
      pageSize: 10,
      loading: false
    };
  },
  computed: {
    ...mapState("billRequest", ["allBillRequests", "billRequestMeta"]),
    ...mapGetters({
      paymentModes: "paymentMode/getPaymentModes"
    })
  },
  beforeMount() {
    this.getPaymentModes();
  },
  mounted() {
    this.paginate();
  },
  methods: {
    ...mapActions({
      getAllBillRequests: "billRequest/getAllBillRequests",
      generateBill: "billRequest/generateBill",
      createSale: "sale/createSale",
      getPaymentModes: "paymentMode/getPaymentModes"
    }),
    ...mapMutations("sale", ["setSale"]),
    async handleGenerateBill(row) {
      try {
        // this.$set(row, "generating", true);

        // Call backend API to generate bill
        console.log(row);
        const response = await this.generateBill(row.serviceRequestId);

        // Create saleData from the response, similar to handleConvertQuotationToSale
        const saleData = {
          userId: response.userId,
          products: response.products,
          date: response.date || new Date(),
          createdBy: response.createdBy,
          discount: response.discount || 0,
          paymentModeId:
            this.paymentModes && this.paymentModes.length > 0
              ? this.paymentModes[0].paymentModeId
              : null,
          paymentNote: response.paymentNote || "",
          amountPaid: response.amountPaid || 0
        };

        // Set sale in store and create sale
        await this.setSale(saleData);
        // await this.createSale(saleData);

        // Redirect to POS screen
        this.$router.push({
          path: `/billRequests/${row.id}`,

          
        });
      } catch (error) {
        console.error("Error generating bill:", error);
        // this.$notify({
        //   message:
        //     error.response?.data?.message ||
        //     error.message ||
        //     "Error generating bill. Please try again.",
        //   type: "danger",
        //   title: "Error"
        // });
      } finally {
        this.$set(row, "generating", false);
      }
    },
    setPagination(data) {
      this.pageSize = data.perPage;
      this.paginate(data.page);
    },
    paginate(page = 1) {
      this.loading = true;
      let query = {
        page,
        perPage: this.pageSize
      };
      this.getAllBillRequests(query)
        .then((res) => {
          console.log(res);
          this.meta = res.meta;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
